export default __webpack_public_path__ + "static/media/environment-variables.84b861cf.png";